export enum CommonComponents {
    Header = 'header',
    Footer = 'footer',
    MobileMenu = 'mobile-menu',
    Preloader = 'preloader',
    Subscribe = 'subscribe',
    AccordionsList = 'accordions-list',
    LandscapePlacehoder = 'landscape-placeholder'
}
